export const namespace = 'securities'
